import React from 'react'
import {
  MobileStepper,
  Button,
  Grid,
  Box
} from '@mui/material'

const Stepper = ({ activeStep, handleNext, handleBack, handleClose, className, handleFinish, hasNextPhase }) => {
  const renderFinishButton = () =>
    hasNextPhase
      ? <Button onClick={handleFinish} color='primary' variant='contained' data-test='onboarding-finish' disableElevation>Next&nbsp;&nbsp;&nbsp;{'>'}</Button>
      : <Button onClick={handleFinish} color='primary' variant='contained' data-test='onboarding-finish' disableElevation>Finish</Button>

  const renderButtonsByStep = () => {
    if (activeStep === 0) {
      return (
        <Grid item container xs justifyContent='flex-end'>
          <Grid item>
            <Button onClick={handleNext} color='primary' variant='contained' data-test='onboarding-next' disableElevation>Next&nbsp;&nbsp;&nbsp;{'>'}</Button>
          </Grid>
        </Grid>
      )
    } else {
      return (
        <Grid item container xs justifyContent='flex-end' spacing={3}>
          <Grid item xs={6}>
            <Box>
              <Button onClick={handleBack} data-test='onboarding-back' variant='outlined'>{'<'}</Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            {renderFinishButton()}
          </Grid>
        </Grid>
      )
    }
  }

  return (
    <Grid
      container direction='row'
      className={className}
    >
      <Grid item xs={4}>
        <Button onClick={handleClose} variant='outlined' data-test='onboarding-do-it-later'>Do it later</Button>
      </Grid>
      <Grid
        item xs={3}
        container
        justifyContent='center'
        alignContent='center'
      >
        <Grid item>
          <MobileStepper
            variant='dots'
            steps={2}
            position='static'
            activeStep={activeStep}
          />
        </Grid>
      </Grid>
      {renderButtonsByStep()}
    </Grid>
  )
}

export default Stepper
